import { ShortView } from "./ShortView";
export default ShortView;	